/*
 * @Author: lzh
 * @Date: 2022-09-15 11:09:18
 * @LastEditors: lbh
 * @LastEditTime: 2025-10-23 14:52:20
 * @Description: file content
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
// 引入各个语言配置文件
import zh from "./config/zh";
import en from "./config/en";
import hk from "./config/hk";
import compare from "./config/compare";

import { Locale } from "vant";
import enUS from "vant/es/locale/lang/en-US";
import zhCN from "vant/es/locale/lang/zh-CN";
import zhHK from "vant/es/locale/lang/zh-HK";


import menuHK from "./config/hk/menu";
import menuZh from "./config/zh/menu";
import menuEn from "./config/en/menu";

import kioskHk from "./config/hk/kiosk";
import kioskZh from "./config/zh/kiosk";
import kioskEn from "./config/en/kiosk";

import whatsappHk from './config/hk/whatsapp';
import whatsappEn from './config/en/whatsapp';
import whatsappZh from './config/zh/whatsapp';

import couponReadListZh from "./config/zh/couponReadList";
import couponReadListEn from "./config/en/couponReadList";
import couponReadListHk from "./config/hk/couponReadList";

import brandHk from "./config/hk/brand";
import brandZh from "./config/zh/brand";
import brandEn from "./config/en/brand";
import areaHk from "./config/hk/area";
import areaZh from "./config/zh/area";
import areaEn from "./config/en/area";

import migratedActivities from "./config/modules/activities";
import migratedAddress from "./config/modules/address";
import migratedApp from "./config/modules/app";
import migratedAuth from "./config/modules/auth";
import migratedCommon from "./config/modules/common";
import migratedGsa from "./config/modules/gsa";
import migratedOrder from "./config/modules/order";
import migratedPc from "./config/modules/pc";
import migratedQueue from "./config/modules/queue";
import migratedRestaurant from "./config/modules/restaurant";


const getNowLocale = () =>
  localStorage.getItem("locale") ||
  localStorage.getItem("app_language") ||
  compare.get();

// ? 將各入口使用的語言標識統一為 i18n 已註冊的 locale
const normalizeLocale = (locale, fallbackLocale = "hk") => {
  // * 兼容 App、瀏覽器及舊緩存使用的語言格式
  let normalizedLocale = String(locale || "")
    .trim()
    .toLowerCase()
    .replace(/_/g, "-");
  if (
    normalizedLocale === "hk" ||
    /^zh-hant(?:-|$)/.test(normalizedLocale) ||
    /^zh-(?:hk|mo|tw)(?:-|$)/.test(normalizedLocale)
  ) {
    return "hk";
  }
  if (
    ["cn", "zh"].includes(normalizedLocale) ||
    /^zh-hans(?:-|$)/.test(normalizedLocale) ||
    /^zh-(?:cn|sg)(?:-|$)/.test(normalizedLocale)
  ) {
    return "cn";
  }
  if (/^en(?:-|$)/.test(normalizedLocale)) return "en";
  return fallbackLocale;
};

const migratedModules = {
  activities: migratedActivities,
  address: migratedAddress,
  app: migratedApp,
  auth: migratedAuth,
  common: migratedCommon,
  gsa: migratedGsa,
  order: migratedOrder,
  pc: migratedPc,
  queue: migratedQueue,
  restaurant: migratedRestaurant,
};

// ? 將舊 namespace 內的 key 補充為可使用點號查找的格式
const addNormalizedKeyAliases = (messages) => {
  // * 保留原 key 兼容未遷移入口，同時提供空格轉底線的新 key
  return Object.keys(messages).reduce((result, namespace) => {
    const namespaceMessages = result[namespace];
    if (
      !namespaceMessages ||
      typeof namespaceMessages !== "object" ||
      Array.isArray(namespaceMessages)
    ) {
      return result;
    }
    Object.keys(namespaceMessages).forEach((key) => {
      const normalizedKey = String(key)
        .trim()
        .replace(/[^A-Za-z0-9_\u00C0-\uFFFF]+/g, "_")
        .replace(/_+/g, "_");
      if (normalizedKey && namespaceMessages[normalizedKey] === undefined) {
        namespaceMessages[normalizedKey] = namespaceMessages[key];
      }
    });
    return result;
  }, messages);
};

// ? 合併按功能拆分的舊翻譯資料，保留既有 namespace 內容
const mergeMigratedModules = (messages, locale) => {
  // * 相同 namespace 採淺層合併，避免覆蓋目前已在 vue-i18n 維護的翻譯
  return Object.keys(migratedModules).reduce((result, namespace) => {
    result[namespace] = {
      ...migratedModules[namespace][locale],
      ...(result[namespace] || {}),
    };
    return result;
  }, { ...messages });
};

let _zh = addNormalizedKeyAliases(mergeMigratedModules({
  ...zh,
  ...menuZh,
  ...kioskZh,
  ...whatsappZh,
  ...couponReadListZh,
  ...brandZh,
  ...areaZh,
}, "cn"));
let _hk = addNormalizedKeyAliases(mergeMigratedModules({
  ...hk,
  ...menuHK,
  ...kioskHk,
  ...whatsappHk,
  ...couponReadListHk,  
  ...brandHk,
  ...areaHk,
}, "hk"));
let _en = addNormalizedKeyAliases(mergeMigratedModules({
  ...en,
  ...menuEn,
  ...kioskEn,
  ...whatsappEn,
  ...couponReadListEn,
  ...brandEn,
  ...areaEn,
}, "en"));

// 创建vue-i18n实例i18n
const i18n = new VueI18n({
  // 设置默认语言
  locale: normalizeLocale(getNowLocale()), // 语言标识
  // 添加多语言（每一个语言标示对应一个语言文件）
  messages: {
    cn: _zh,
    en: _en,
    hk: _hk,
  },
  silentTranslationWarn: true,
});

i18n.setLocale = (locale) => {
  const currentLocale = normalizeLocale(i18n.locale || getNowLocale());
  locale = normalizeLocale(locale || getNowLocale(), currentLocale);
  i18n.locale = locale;
  if (locale == "en") Locale.use("en-US", enUS);
  else if (locale == "hk") Locale.use("zh-HK", zhHK);
  else Locale.use("zh-CN", zhCN);
  localStorage.setItem("locale", locale);
  localStorage.setItem(
    "app_language",
    {
      hk: "zh-hk",
      cn: "zh-cn",
      en: "en",
    }[locale]
  );
  return locale;
};

// ? 取得 App 舊橋接仍在使用的語言標識
i18n.getAppLocale = () => {
  // * App 與舊頁面統一透過目前 vue-i18n locale 轉換，不再讀第二份語言狀態
  return {
    hk: "zh-hk",
    cn: "zh-cn",
    en: "en",
  }[normalizeLocale(i18n.locale)];
};

// ? 取得後端 languageId
i18n.getLanguageId = () => {
  // * 簡體使用 cn 作執行時 key，但後端仍維持 languageId 2
  return {
    en: 1,
    cn: 2,
    hk: 3,
  }[normalizeLocale(i18n.locale)];
};

i18n.check = (hk, en, cn) => {
  let locale = normalizeLocale(i18n.locale);
  if (locale === "hk") {
    return hk;
  } else if (locale === "cn") {
    return cn || hk;
  } else {
    return en || hk;
  }
};

// 暴露i18n
export default i18n;
